<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <el-button @click="searchs">查询</el-button>
      <el-button @click="orderExcel" v-if="ERP.isPermission(4003002006)">导出</el-button>
      <div style="width: 99%">
        <el-descriptions :column="2" border size="mini" style="margin-top: 10px" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
          <el-descriptions-item label="缴费日期">
            <el-date-picker size="mini" v-model="datevalue" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="房产名称">
            <el-select style="width: 100%" v-model="search" size="mini" filterable remote clearable reserve-keyword placeholder="可搜索房产/客户姓名" :remote-method="remoteMethod" :loading="loading">
              <el-option v-for="item in selectList" :key="item.id" :label="item.house" :value="item.house"></el-option>
            </el-select>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-table
        ref="multipleTable"
        height="600"
        :data="desserts"
        border
        style="width: 99%;margin-top: 10px;"
      >
        <el-table-column prop="id" label="ID" width="50"></el-table-column>
        <el-table-column
          prop="number"
          label="编号"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="h_name"
          label="姓名"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="h_name_date"
          label="收费对象"
          width="500"
        ></el-table-column>
        <el-table-column
          prop="charge"
          label="金额"
          width="80"
        ></el-table-column>
        <el-table-column
          label="支付"
          prop="pays_name"
          width="150"
        ></el-table-column>
        <el-table-column label="状态" prop="state" width="100">
          <!-- <template slot-scope="data">
            <span v-if="data.row.state == 2 || item.state == 4">已完成</span
            ><span v-if="data.row.state == 5" style="color: red">已退款</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="date" label="时间" width="180"></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="data">
            <el-button
              type="text"
              v-if="ERP.isPermission(4003002002)"
              @click="beizhu(data.row.id, data.row.beizhus)"
            >
              备注
            </el-button>
            <el-button
              type="text"
              v-if="ERP.isPermission(4003002004)"
              @click="chakan(data.row)"
            >
              详情
            </el-button>
           <!-- <el-button
              type="text"
              v-if="
                data.row.state == 2 &&
                ERP.isPermission(4003002005) &&
                data.row.pays_name != '预付款（预收款结转）'
              "
              @click="congxiao(data.row.id)"
            >
              冲销
            </el-button> -->
            <!-- <el-button
              type="text"
              v-if="data.row.state == 2"
              @click="billPrintClick(data.row)"
            >
              打印
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <v-divider></v-divider>

      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change" show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
      <!-- 查看详情 -->
      <Modal v-model="modal12" ok-text="确定" width="500" title="查看详情">
        <div v-if="chakana['id']">
          <p>ID：{{ chakana["id"] }}</p>
          <p>房产ID：{{ chakana["house_id"] }}</p>
          <p>编号：{{ chakana["number"] }}</p>
          <p>姓名：{{ chakana["h_name"] }}</p>
          <p>房产：{{ chakana.h_name_date }}</p>
          <p>费用：{{ chakana["charge"] }}</p>
          <p>
            状态：<span v-if="chakana.state == 1">待支付</span
            ><span v-if="chakana.state == 2">已支付</span
            ><span v-if="chakana.state == 5">已退款</span>
          </p>
          <p>时间：{{ chakana["date"] }}</p>
          <p style="margin-top: 10px">费用详情</p>
          <div v-for="item in orderDates" :key="item.id">
            <p style="margin-top: 5px"></p>
            <p>费用编号：{{ item.number }}</p>
            <p>费用名称：{{ item.charge_name }}</p>
            <p>
              费用金额：<span class="textzti">{{ item.charge }}元</span>
            </p>
            <p>
              计费周期：<span class="textzti"
                >{{ item.startDate }}-{{ item.endDate }}</span
              >
            </p>
          </div>
        </div>
      </Modal>
      <!-- 查账中行 -->
      <Modal v-model="modal13" ok-text="确定" width="500" title="查单详情">
        <div v-if="chazhangs.hdlSts">
          <p>
            查询结果：<span v-if="chazhangs.hdlSts == 'A'">成功</span
            ><span v-if="chazhangs.hdlSts == 'B'">失败</span
            ><span v-if="chazhangs.hdlSts == 'K'">未知</span>
          </p>
          <p>
            商户号：<span>{{ chazhangs.merchantNo }}</span>
          </p>
          <p>
            订单号：<span>{{ chazhangs.orderNo }}</span>
          </p>
          <p>
            类型：<span v-if="chazhangs.tranCode == '01'">支付</span
            ><span v-if="chazhangs.tranCode == '03'">批量退款</span
            ><span v-if="chazhangs.tranCode == '06'">退款</span>
          </p>
          <p>
            金额：<span>{{ chazhangs.tranAmount }}</span>
          </p>
          <p>
            状态：<span v-if="chazhangs.tranStatus == '0'">待处理</span
            ><span v-if="chazhangs.tranStatus == '1'">成功</span
            ><span v-if="chazhangs.tranStatus == '2'">失败</span
            ><span v-if="chazhangs.tranStatus == '3'">未知</span>
          </p>
        </div>
      </Modal>
      <!-- 查账微信 -->
      <Modal v-model="modal15" ok-text="确定" width="500" title="查单详情">
        <div v-if="wxChazhangs.trade_state">
          <p>微信商户：{{ wxChazhangs.sub_mch_id }}</p>
          <p>订单编号：{{ wxChazhangs.out_trade_no }}</p>
          <p>订单金额：{{ wxChazhangs.total_fee / 100 }}</p>
          <p>
            查询结果：<span v-if="wxChazhangs.trade_state == 'SUCCESS'"
              >支付成功</span
            >
            <span v-if="wxChazhangs.trade_state == 'REFUND'">支付退款</span>
            <span v-if="wxChazhangs.trade_state == 'NOTPAY'">未支付</span>
            <span v-if="wxChazhangs.trade_state == 'CLOSED'">已关闭</span>
            <span v-if="wxChazhangs.trade_state == 'REVOKED'"
              >已撤销(刷卡支付)</span
            >
            <span v-if="wxChazhangs.trade_state == 'USERPAYING'"
              >用户支付中</span
            >
            <span v-if="wxChazhangs.trade_state == 'PAYERROR'"
              >支付失败(其他原因，如银行返回失败)</span
            >
            <span v-if="wxChazhangs.trade_state == 'ACCEPT'"
              >已接收，等待扣款</span
            >
          </p>
          <p>支付类型：微信支付</p>
        </div>
      </Modal>
      <!-- 备注 -->
      <Modal
        v-model="modal16"
        ok-text="确定"
        width="500"
        title="备注"
        @on-ok="okbeiz"
      >
        <div>
          <el-form label-width="80px">
            <el-form-item label="备注">
              <el-input v-model="beizhus"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </Modal>
    </div>
    <!-- 打印display: none; -->
    <div
      style="
        position: absolute;
        bottom: 100px;
        left: 500px;
        width: 700px;
        display: none;
      "
    >
      <div id="printBill">
        <div style="font-size: 8px; color: #141414; font-family: 楷体">
          <div
            style="
              width: 100%;
              text-align: center;
              margin-top: 30px;
              font-size: 20px;
            "
          >
            中奥物业 收款收据
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 70%">房号：{{ goods.h_name_date }}</div>
            <div style="width: 30%; margin-left: 220px">
              付款方式：{{ goods.pays }}
            </div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%">业主：{{ goods.h_name }}</div>
            <div style="width: 33%">收据单号：{{ goods.bill_number }}</div>
            <div style="width: 34%; text-align: right; margin-right: 25px">
              开票日期：{{ goods.date1 }}
            </div>
          </div>
          <div style="margin-top: 1px; line-height: 17px">
            <table
              align="center"
              style="width: 100%; border-collapse: collapse"
            >
              <tr>
                <th
                  style="border: 1px solid #000000; width: 150px"
                  align="center"
                  valign="middle"
                >
                  收费项目
                </th>
                <th
                  style="border: 1px solid #000000; width: 200px"
                  align="center"
                  valign="middle"
                >
                  计费周期
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  class="ddd"
                  align="center"
                  valign="middle"
                >
                  面积
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  数量
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  单价
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  违约金
                </th>
                <th
                  style="border: 1px solid #000000; width: 90px"
                  align="center"
                  valign="middle"
                >
                  金额
                </th>
              </tr>
              <tr v-for="it in order">
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ it.chargeitem_name }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ it.startDate }}-{{ it.endDate }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ it.charging }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ it.xsc_Amount }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ it.charges }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ it.delaySum }}
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ it.charge }}
                </td>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  合计（大写）：
                </td>
                <td
                  style="border: 1px solid #000000; text-align: left"
                  colspan="4"
                  align="center"
                  valign="middle"
                >
                  <span style="margin-left: 5px">{{ capitalize }}</span>
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  （小写）：
                </td>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  {{ goods.charge }}
                </td>
              </tr>
              <tr>
                <td
                  style="border: 1px solid #000000"
                  align="center"
                  valign="middle"
                >
                  备注：
                </td>
                <td
                  style="border: 1px solid #000000; text-align: left"
                  colspan="6"
                  align="center"
                  valign="middle"
                >
                  <span style="margin-left: 5px">{{ goods.beizhus }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div style="width: 70%; margin-top: 20px">
            说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%">开票人：{{ login }}</div>
            <div style="width: 33%">收款人：{{ login }}</div>
            <div style="width: 34%; text-align: right; margin-right: 150px">
              收款单位（盖章）
            </div>
          </div>
          <div style="margin-top: 7px; display: flex; width: 100%">
            <div style="width: 33%"></div>
            <div style="width: 33%"></div>
            <div style="width: 34%; text-align: right; margin-right: 70px">
              打印时间：{{ goods.date2 }}
            </div>
          </div>
          <div style="text-align: center; margin-top: 7px">
            打印次数<span style="margin-left: 30px">{{ goods.frequency }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js";
import ErpTree from "../Common/erp-tree";
// print-is
import print from "print-js";
export default {
  name: "OrderListDate",
  components: { ErpTree },
  data() {
    return {
      project_id: "",
      selectList: [],
      login: "",
      indexs: "",
      modal12: false,
      modal13: false,
      modal16: false,
      modal15: false,
      datevalue: [],
      oid: 0,
      beizhus: "",
      wxChazhangs: {
        trade_state: "",
      },
      chazhangs: {
        hdlSts: "",
      },
      loading: false,
      options: [
        {
          value: "",
          label: "",
        },
      ],
      options1: [
        {
          id: 1,
          label: "编号",
        },
        {
          id: 2,
          label: "姓名",
        },
      ],
      value: "",
      value1: "",
      value2: 1,
      input1: "",
      desserts: "",
      cs: "",
      total: 0,
      page: 12,
      search: "",
      anxiu: "保存",
      chakana: [],
      state: 0,
      orderDates: [],
      sdate: "",
      enddate: "",
      homeName: "",
      order: [],
      goods: [],
      capitalize: "",
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    var t = Date.parse(new Date()) / 1000; //时间戳
    var login = window.localStorage.getItem("login");
    // ERP.showLoading();
    // this.$Loading.start();
    // this.$myhttp
    //   .get("admin/getorderList?login=" + login, {
    //     "Content-Type": "application/json",
    //   })
    //   .then((backdata) => {
    //     // 异步执行成功后
    //     // this.value1 = backdata.data[0];//开启不查全部
    //     this.value = backdata.data;
    //     this.$myhttp
    //       .get(
    //         "admin/orderDate?id=1" +
    //           "&company=" +
    //           this.value +
    //           "&company1=" +
    //           this.value2 +
    //           "&t=" +
    //           t +
    //           "&distinguish=0",
    //         {
    //           "Content-Type": "application/json",
    //         }
    //       )
    //       .then((backdata) => {
    //         // 异步执行成功后
    //         this.desserts = backdata.data[0];
    //         this.total = backdata.data[1];
    //         this.page = backdata.data[2];
    //         this.$Loading.finish();
    //         ERP.hideLoading();
    //       });
    //   });
    //加载公司列表和归属列表
    this.$myhttp
      .get("admin/getcompany", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        // 异步执行成功后
        this.options = backdata.data[0];
      });
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //打印
    billPrintClick(item) {
      this.login = window.localStorage.getItem("login");
      this.$myhttp
        .post("admin/getPrint", item, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.goods = backdata.data.goods;
          this.order = backdata.data.order;
          this.capitalize = this.transCnMoney(this.goods.charge);
          this.day();
        });
    },
    //数字转大写
    transCnMoney(number) {
      var CN_MONEY = "";
      var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
      number = parseFloat(number).toFixed(2).toString(); //浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
      var dot = number.indexOf("."); //将从小数点开始分开
      if (dot >= 0) {
        number = number.substring(0, dot) + number.substr(dot + 1, 2);
        CN_UNIT = CN_UNIT.substr(CN_UNIT.length - number.length);
        for (var i = 0; i < number.length; i++) {
          CN_MONEY +=
            "零壹贰叁肆伍陆柒捌玖".substr(number.substr(i, 1), 1) +
            CN_UNIT.substr(i, 1);
        }
        return CN_MONEY.replace(/零角零分$/, "整")
          .replace(/零[仟佰拾]/g, "零")
          .replace(/零{2,}/g, "零")
          .replace(/零([亿|万])/g, "$1")
          .replace(/零+元/, "元")
          .replace(/亿零{0,3}万/, "亿")
          .replace(/^元/, "零元");
      } else {
      }
    },
    //打印
    day() {
      let _this = this;
      setTimeout(function () {
        const style = "@page {margin:0 10mm};"; //打印时去掉眉页眉尾
        printJS({
          printable: "printBill", // 标签元素id
          type: "html",
          header: "",
          targetStyles: ["*"],
          scanStyles: false, //打印必须加上，不然页面上的css样式无效
          style,
          //打开打印界面
          onLoadingStart: () => {
            console.log("loading-start");
          },
          //界面打开成功结束
          onLoadingEnd: () => {
            console.log("loading-end");
          },
          //关闭回调
          onPrintDialogClose: () => {
            console.log("关闭回调");
          },
          onError: (e) => {
            console.log("打印失败");
          },
        });
      }, 100);
    },

    //弹窗查看
    chakan(e) {
      //   console.log(e);
      this.$myhttp.get("admin/getOrderDate?oid=" + e.orderid + "&search=" + this.search, {
          "Content-Type": "application/json",
        }).then((backdata) => {
          // 异步执行成功后
          this.orderDates = backdata.data;
        });
      this.chakana = e;
      this.modal12 = true;
    },
    //冲销
    congxiao(id) {
      this.$confirm("确定冲销吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$myhttp
            .post(
              "admin/congxiao",
              { id: id },
              {
                "Content-Type": "application/x-www-form-urlencoded",
              }
            )
            .then((backdata) => {
              // 异步执行成功后
              if (backdata.data.code == 200) {
                this.change(1);
                this.loading = false;
                this.$Message.success("操作成功!");
              }
            });
        })
        .catch(() => {});
    },
    //确定退款
    xiugai(e, charge, item) {
      this.$confirm("确定退款吗, 是否继续？退款金额：" + charge, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          if (item.pays == "wx") {
            //微信退款
            var data = { number: item.number };
            this.$myhttp
              .post("index/wxRefund", data, {
                "Content-Type": "application/json",
              })
              .then((backdata) => {
                // 异步执行成功后
                // console.log(backdata.data);
                var data = backdata.data;
                if (data.code == 201) {
                  this.$Message.error(data.data);
                  return false;
                }
                if (data.code == 200) {
                  //操作成功查询查询订单
                  this.$myhttp
                    .get(
                      "admin/orderDate?id=1" +
                        "&company=" +
                        this.value +
                        "&company1=" +
                        this.value2 +
                        "&distinguish=0",
                      {
                        "Content-Type": "application/json",
                      }
                    )
                    .then((backdata) => {
                      // 异步执行成功后
                      this.desserts = backdata.data[0];
                      this.total = backdata.data[1];
                      this.page = backdata.data[2];
                    });
                  this.$Message.success(data.data);
                  return false;
                }
              });
          } else {
            //中行退款
            var merchantNo = item.merchantNo;
            var merch = merchantNo.substring(merchantNo.length - 6);
            var shu = Math.floor(Math.random() * 100000000000);
            var mRefundSeq = merch + "" + shu;
            this.$Loading.start();
            var dadesa = {
              merchantNo: item.merchantNo,
              mRefundSeq: mRefundSeq,
              curCode: "001",
              refundAmount: item.charge,
              orderNo: item.number,
            };
            this.$payhttp
              .post("wxxcxRefundOrder/payRefundOrder", dadesa, {
                "Content-Type": "application/x-www-form-urlencoded",
              })
              .then((backdata) => {
                // 异步执行成功后
                // console.log(backdata.data.data);
                var forder = backdata.data.data;
                if (
                  forder.orderNo &&
                  forder.mRefundSeq &&
                  forder.dealStatus != 1 &&
                  forder.returnActFlag == 3 &&
                  forder.merchantNo
                ) {
                  var statue = {
                    merchantNo: item.merchantNo,
                    mRefundSeq: mRefundSeq,
                    refundAmount: item.charge,
                    orderNo: item.number,
                  };
                  this.$myhttp
                    .post("admin/payOrderstatus", statue, {
                      "Content-Type": "application/x-www-form-urlencoded",
                    })
                    .then((backdata) => {
                      // 异步执行成功后
                      // console.log(backdata.data)
                      //操作成功查询查询订单
                      this.$myhttp
                        .get(
                          "admin/orderDate?id=1" +
                            "&company=" +
                            this.value +
                            "&company1=" +
                            this.value2 +
                            "&distinguish=0",
                          {
                            "Content-Type": "application/json",
                          }
                        )
                        .then((backdata) => {
                          // 异步执行成功后
                          this.desserts = backdata.data[0];
                          this.total = backdata.data[1];
                          this.page = backdata.data[2];
                        });
                      this.$Message.success("操作成功!");
                    });
                } else {
                  // console.log("退款失败")
                  this.$message({
                    type: "info",
                    message: "操作退款失败",
                  });
                }
                this.$Loading.finish();
              });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    modals(e) {
      if (this.state != e) {
        this.$Loading.start();
        this.state = e;
        this.$myhttp
          .get(
            "admin/orderDate?id=1" +
              "&search=" +
              this.search +
              "&company=" +
              this.value +
              "&company1=" +
              this.value2 +
              "&state=" +
              this.state,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          });
      }
    },
    //获得当前多少页,分页
    change(e) {
      ERP.showLoading();
      this.$Loading.start();
      this.$myhttp
        .get(
          "admin/orderDate?id=" +
            e +
            "&search=" +
            this.search +
            "&company=" +
            this.value +
            "&company1=" +
            this.value2 +
            "&state=" +
            this.state +
            "&sdate=" +
            this.sdate +
            "&enddate=" +
            this.enddate +
            "&homeName=" +
            this.homeName,
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
          ERP.hideLoading();
        });
    },
    //搜索
    searchs() {
      if(this.project_id == ''){
        this.$Message.error("点击树选择项目");
        return false;
      }
      //datevalue
      if (this.datevalue != null) {
        var d = this.datevalue[0]; //开始时间
        var e = this.datevalue[1]; //结束时间
        this.sdate = new Date(d).getTime() / 1000;
        this.enddate = new Date(e).getTime() / 1000;
      } else {
        this.sdate = "";
        this.enddate = "";
      }
      this.$Loading.start();
      this.$myhttp
        .get(
          "admin/orderDate?search=" +
            this.search +
            "&id=1" +
            "&company=" +
            this.value +
            "&company1=" +
            this.value2 +
            "&state=" +
            this.state +
            "&sdate=" +
            this.sdate +
            "&enddate=" +
            this.enddate,
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        });
    },
    //查账
    chazhang(item) {
      if (item.pays == "wx") {
        //微信订单查账
        // console.log(item);
        var dadesa = { type: 2, number: item.number };
        this.$myhttp
          .post("index/getWxPays", dadesa, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            // console.log(backdata.data)
            this.wxChazhangs = backdata.data.datas;
            this.modal15 = true;
          });
      } else {
        //中行订单查账
        var dadesa = { merchantNo: item.merchantNo, orderNo: item.number };
        this.$payhttp
          .post("wxxcxQueryTrans/payQueryTrans", dadesa, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            console.log(backdata.data);
            this.chazhangs = backdata.data.data;
            this.modal13 = true;
          });
      }
    },
    //备注
    beizhu(id, beizhus) {
      this.beizhus = beizhus;
      this.oid = id;
      this.modal16 = true;
    },
    //备注保存
    okbeiz() {
      var date = { id: this.oid, beizhu: this.beizhus };
      // console.log(date);
      this.$myhttp
        .post("admin/beizhuAdd", date, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.$myhttp
            .get(
              "admin/orderDate?id=1" +
                "&company=" +
                this.value +
                "&company1=" +
                this.value2 +
                "&distinguish=0",
              {
                "Content-Type": "application/json",
              }
            )
            .then((backdata) => {
              // 异步执行成功后
              this.desserts = backdata.data[0];
              this.total = backdata.data[1];
              this.page = backdata.data[2];
              this.$Loading.finish();
            });
          this.$Message.success("保存成功");
        });
    },
    //导出
    orderExcel(e) {
      //datevalue
      if (this.datevalue != null) {
        var d = this.datevalue[0]; //开始时间
        var e = this.datevalue[1]; //结束时间
        this.sdate = new Date(d).getTime() / 1000;
        this.enddate = new Date(e).getTime() / 1000;
      } else {
        this.sdate = "";
        this.enddate = "";
      }
      var login = window.localStorage.getItem("login");
      var token = window.localStorage.getItem("token");
      // console.log(imgurl);
      this.$Message.success("导出中...");
      window.location.href =
        imgurl +
        "/admin/orderExcel?search=" +
        this.search +
        "&id=1" +
        "&company=" +
        this.value +
        "&company1=" +
        this.value2 +
        "&state=" +
        this.state +
        "&sdate=" +
        this.sdate +
        "&enddate=" +
        this.enddate +
        "&login_name=" +
        login +
        "&token=" +
        token;
    },
    nodeClick(data) {
      this.search = "";
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      // this.homeName=tree_str;
      this.search = tree_str;
      // this.remoteMethod(tree_str);
      this.change(1);
    },
  },
};
</script>
<style>
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.textzti {
  color: brown;
}
.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/listDate.vue